import { AccountingErrorResponse, GroupUserRole } from 'multirpc-sdk';
import { AxiosError } from 'axios';

import { EMAIL_HASH_QUERY_PARAM_NAME } from './const';

export type ErrorMessageGetter = (
  error: AxiosError<AccountingErrorResponse>,
  email?: string,
) => string;

export enum TeamInvitationQueryParamsName {
  Group = 'group',
  Email = 'email',
  Token = 'token',
  Role = 'role',
  Gname = 'gname',
  ExpiresAt = 'expires_at',
}

export interface TeamInvitationQueryParams {
  [TeamInvitationQueryParamsName.Email]?: string; // replaced with email_hash
  [TeamInvitationQueryParamsName.ExpiresAt]: string;
  [TeamInvitationQueryParamsName.Gname]: string;
  [TeamInvitationQueryParamsName.Group]: string;
  [TeamInvitationQueryParamsName.Role]: GroupUserRole;
  [TeamInvitationQueryParamsName.Token]: string;
  // dual-accept: hashed replacement for the plaintext `email`, carried through
  // so a reconstructed invite URL keeps it for post-login email matching
  [EMAIL_HASH_QUERY_PARAM_NAME]?: string;
}
